import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { SeriesOptionsType } from 'highcharts';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { UtilidadDashboard } from '../../shared/utilities/utilidad-dashboard';
import { Constantes } from '../../shared/constant/constantes';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { SerieEstadistica } from '../../shared/entities/serie-estadistica';
import { HeaderComponent } from '../../shared/header/header.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-grafica-analitica',
    templateUrl: './grafica-analitica.component.html',
    styleUrls: ['./grafica-analitica.component.css'],
    standalone: true,
    imports: [CommonModule, HeaderComponent, MatIconModule, RouterModule, HighchartsChartModule]
})
export class GraficaAnaliticaComponent implements OnInit, OnDestroy {

  private utilidadDashboard: UtilidadDashboard = new UtilidadDashboard();
  public constantes: Constantes = new Constantes();

  public updateFlag = true;

  public HighchartsCiudad: typeof Highcharts = Highcharts;
  public HighchartsIntradia: typeof Highcharts = Highcharts;
  public HighchartsPI: typeof Highcharts = Highcharts;
  public HighchartsTISF: typeof Highcharts = Highcharts;

  public chartOptionsIntradia: Highcharts.Options = this.utilidadDashboard.initChartGenerico(1, 'area');
  public chartOptionsPI: Highcharts.Options = this.utilidadDashboard.initChartOptions();
  public chartOptionsTISF: Highcharts.Options = this.utilidadDashboard.initChartTISF();

  public chartOptionsCiudad: Highcharts.Options = this.utilidadDashboard.initChartCiudades();
public chartOptionsOBMRI: Highcharts.Options = this.utilidadDashboard.initChartOptions();

  //PRECIOS E INFLACIÓN - BAR RACE
  public accionBotonBarRace: string = 'play';
  private barRaceInterval: any;
  public barRaceDatoMin: number = 0;
  public barRaceDatoMax: number = 0;
  public barRaceRangoFechaInicio: Date = new Date();
  public barRaceRangoFechaFin: Date = new Date();
  public mapaDataSet: Map<number, Map<any, any>> = new Map<number, Map<any, any>>();

  private listaFechas: Array<any> = new Array();
  public indiceActual: number = 0;
  public datoActual: number = this.barRaceDatoMin;
  public fechaSlide: string = '';
  private unidad: string = '';

  //INTRADIA
  private barRaceIntervalIntradia: any;
  public listaCompletaIntradia: Array<any> = new Array();
  public listaIntradia: Array<any> = new Array();
  public indiceActualIntradia: number = 0;
  public datoActualIntradia: any[] = [];
  public barRaceIntradiaMin: number = 0;
  public barRaceIntradiaMax: number = 0;
  public fechaIntradiaSlide: string = '';
  public accionBotonIntradiaBarRace = 'play';

  public tabChart: string = '';

  @Input() seccion: string = '';

  @Input() dataSeriesDivisionGasto: Array<SerieEstadistica> = new Array();

  constructor(private router: Router, private route: ActivatedRoute, private service: VisualizadorService, private location: Location) {
  }

  ngOnInit(): void {
    const currentUrl = this.location.path();
    this.service.generaTagsHtmlSEO('Gráfica análitica','Gráfica análitica','análitica, gráfica',currentUrl);

  
    var seccion = this.route.snapshot.paramMap.get('seccion')!;
    if (seccion == null) {
      seccion = this.seccion;
    }
    //this.generaGrafica(this.seccion);
    this.generaGrafica(seccion);
  }

  private generaGrafica(seccionTab: string) {
    this.finalizarIntervalIPC();
    switch (seccionTab) {
      case 'Precios e inflación'://'Precios e inflación':
        this.tabChart = 'chartPI';
        this.accionBotonBarRace = 'play';
        this.updateChartPI();
        this.finalizarIntervalIntradia();
        break;
      case 'Precios e inflación ciudad'://'Precios e inflación':
        this.tabChart = 'chartPICiudad';
        this.updateChartPICiudad();
        this.finalizarIntervalIntradia();
        break;
      case 'Tasas de interés y sector financiero':
        this.tabChart = 'chartTISF';
        this.finalizarIntervalIPC();
        this.updateChartTISF();
        this.finalizarIntervalIntradia();
        break;
      case 'Operaciones del Banco en los mercados y reservas internacionales':
        this.tabChart = 'chartOBMRI';
        this.finalizarIntervalIPC();
        this.updateChartOBMRI();
        this.finalizarIntervalIntradia();
        break;
      case 'Sector externo, tasas de cambio y derivados':
        this.tabChart = 'chartSETCD';
        this.finalizarIntervalIPC();
        //this.generaInfoTile('1');
        this.updateChartSETCD();
        break;
      case 'Actividad económica, mercado laboral y cuentas financieras':
        this.tabChart = 'chartAEMLCF';
        this.finalizarIntervalIPC();
        //this.generaInfoTile('15271,15416,16610');
        this.updateChartAEMLCF();
        this.finalizarIntervalIntradia();
        break;
      case 'Sector público y deuda pública':
        this.tabChart = 'chartSPDP';
        this.finalizarIntervalIPC();
        this.updateChartSPDP();
        this.finalizarIntervalIntradia();
        break;
      default:

        break;
    }
  }

  //1. Precios e inflación
  private updateChartPI() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    if (this.dataSeriesDivisionGasto.length > 0) {
      const listaDivision = this.dataSeriesDivisionGasto;
      var mapaFechas = util.generaMapaFechas(listaDivision);
      this.listaFechas = Array.from(mapaFechas.keys());
      this.datoActual = util.getFechaMinima(mapaFechas);
      this.barRaceDatoMin = 0;
      this.barRaceDatoMax = this.listaFechas.length - 1;
      this.mapaDataSet = util.getMapaDataSet(listaDivision, mapaFechas);
      var dataSerie = util.getData(this.listaFechas[this.barRaceDatoMin], this.mapaDataSet);
      console.log('updateChartPI:dataSerie', dataSerie);
      this.fechaSlide = util.formatoFecha(this.datoActual, 'Mensual');
      this.chartOptionsPI = util.getChartOptionsPI(this.fechaSlide, this.barRaceDatoMin, dataSerie);
    } else {
      var idSeriesDivision = '15001,15004,15002,15012,15010,15008,15005,15003,15009,15011,15006,15007';
      this.service.getInformacionSerieXTipoDato(idSeriesDivision, 11, 12).subscribe({
        next: (jsonResponse) => {
          const listaDivision = jsonResponse;
          var mapaFechas = util.generaMapaFechas(listaDivision);
          this.listaFechas = Array.from(mapaFechas.keys());
          this.datoActual = util.getFechaMinima(mapaFechas);
          this.barRaceDatoMin = 0;
          this.barRaceDatoMax = this.listaFechas.length - 1;
          this.mapaDataSet = util.getMapaDataSet(listaDivision, mapaFechas);
          var dataserie = util.getData(this.listaFechas[this.barRaceDatoMin], this.mapaDataSet);
          this.fechaSlide = util.formatoFecha(this.datoActual, 'Mensual');
          this.chartOptionsPI = util.getChartOptionsPI(this.fechaSlide, this.barRaceDatoMin, dataserie);
          console.log('chartOptionsPI', this.chartOptionsPI);
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
    }
  }

  private updateChartPICiudad() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    var idSeriesCiudad = '15013,15014,15015,15016,15017,15018,15019,15020,15021,15022,15023,15024,15025,15026,15027,15028,15029,15030,15031,15032,15033,15034,15035';
    this.service.getInformacionSerieXTipoDato(idSeriesCiudad, 20, 1).subscribe({
      next: (jsonResponse) => {
        this.chartOptionsCiudad = util.getChartSpider(jsonResponse);
      },
      error: (error) => {
        console.log("Error inesperado en inflacion", error);
      }
    });
  }

  //2. Tasas de interes y sector financiero
  private updateChartTISF() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    var idSeries = '89,241,65,59,15632';
    var coloresSeries: Map<number, any> = new Map<number, any>();
    coloresSeries.set(89, '#990101');
    coloresSeries.set(241, '#692A70');
    coloresSeries.set(65, '#0F69A1');
    coloresSeries.set(59, '#CDCD05');
    coloresSeries.set(15632, '#077307');

    this.service.getInformacionSerieXTipoDatoXFechaDesde(idSeries, 1, 1, 'year').subscribe({
      next: (jsonResponse) => {
        const listaSeries = jsonResponse;
        this.unidad = listaSeries[0].unidad;
        let listaSerieChart: Array<Highcharts.SeriesOptionsType> = new Array();
        let periodicidadPrincipal: number = 0;
        let periodicidadDescripcion: string = '';
        let titulo: string = 'Monto diario mercado interbancario, TIB, IBR overnight, DTF y Tasa de política monetaria';
        let seriesAxisPosition = util.assignSeriesToYAxis(listaSeries);
        listaSeries.forEach(se => {
          let numY: number = seriesAxisPosition[se.id] ? 1 : 0;
          if (se.id === 15632)
            se.tipoVisualizacion = 'area';
          const ns: Highcharts.SeriesOptionsType = util.getSerieChart(se, numY, coloresSeries.get(se.id));
          listaSerieChart.push(ns);
          if (periodicidadPrincipal === 0 || se.idPeriodicidad < periodicidadPrincipal) {
            periodicidadPrincipal = se.idPeriodicidad;
            periodicidadDescripcion = se.descripcionPeriodicidad;
          }
        });
        this.chartOptionsTISF = util.getAditionalHighchartsOptions(listaSerieChart, titulo, seriesAxisPosition);
      },
      error: (error) => {
        console.log("Error inesperado en getInformacionMenu", error);
      }
    });
  }

  //Operaciones del Banco en los mercados y reservas internacionales
  private updateChartOBMRI() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    var idSeries = '17500,17501,17502,17503';

  }

  //4. Sector externo, tasas de cambio y derivados
  private updateChartSETCD() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    var idSeriesMonedaReserva = '1,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39';
   
    this.service.getMercadoCambiario().subscribe({
      next: (jsonResponse) => {
        this.listaCompletaIntradia = jsonResponse;
        this.listaIntradia.push(this.listaCompletaIntradia[0]);
        this.datoActualIntradia = this.listaCompletaIntradia[0];
        this.barRaceIntradiaMin = 0;
        this.barRaceIntradiaMax = jsonResponse.length - 1;
        const milisegundos: number = Number(this.datoActualIntradia[0]);
        this.fechaIntradiaSlide = util.formatoFecha(milisegundos, 'Diario');
        this.chartOptionsIntradia = util.getHighchartsOptionsIntradia(jsonResponse);
        this.accionBotonIntradiaBarRace = 'play';
        this.iniciarAnimacionIntradia();
      }, error: (error) => {
        console.log("Error inesperado en generaListaOptions.getInformacionSeriesAutocomplete", error);
      }
    });

  }

  //5. Actividad económica, mercado laboral y cuentas financieras
  private updateChartAEMLCF() {
    var util: UtilidadDashboard = new UtilidadDashboard();


  }


  //6. Sector público y deuda pública
  private updateChartSPDP() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    var idSeriesSectorPublico = '16720,16721';

  }

  public iniciarAnimacionPreciosInflacion(): void {
    var util: UtilidadDashboard = new UtilidadDashboard();
    if (this.accionBotonBarRace === 'pause') {
      this.finalizarIntervalIPC();
    } else {
      this.barRaceInterval = setInterval(() => {
        if (this.indiceActual == this.listaFechas.length - 1 && this.accionBotonBarRace === 'play') {
          this.indiceActual = 0;
          this.accionBotonBarRace = 'pause';
        }
        else if (this.indiceActual < this.listaFechas.length - 1) {
          this.accionBotonBarRace = 'pause';
          this.indiceActual = Number(this.indiceActual) + 1;

          var listaSeries: Array<SeriesOptionsType> = this.updateChartData();

          this.chartOptionsPI = {
            subtitle: {
              useHTML: true,
              text: util.formatoFecha(this.datoActual, 'Mensual') + ' <br> <p style="font-size: small;"> Variación anual</p>',
              floating: true,
              //align: 'left',
              y: 60,
              x: 0,
              style: {
                fontSize: '1.3rem',
                textAlign: 'left'
              }
            },
            series: listaSeries,
          }
          
        } else {
          this.finalizarIntervalIPC();
        }
      }, 1500);
    }
  }

  ngOnDestroy() {
    this.finalizarIntervalIPC();
    this.finalizarIntervalIntradia();
  }

  public iniciarAnimacionIntradia() {
    var util: UtilidadDashboard = new UtilidadDashboard();
    if (this.accionBotonIntradiaBarRace === 'pause') {
      this.finalizarIntervalIntradia();
    } else {
      this.barRaceIntervalIntradia = setInterval(() => {
        if (this.indiceActualIntradia == this.listaCompletaIntradia.length - 1 && this.accionBotonIntradiaBarRace === 'play') {
          this.indiceActualIntradia = 0;
          this.accionBotonIntradiaBarRace = 'pause';
        }
        else if (this.indiceActualIntradia < this.listaCompletaIntradia.length - 1) {
          this.accionBotonIntradiaBarRace = 'pause';
          this.indiceActualIntradia = Number(this.indiceActualIntradia) + 1;
          this.datoActualIntradia = this.listaCompletaIntradia[this.indiceActualIntradia];
          this.listaIntradia.push(this.listaCompletaIntradia[this.indiceActualIntradia]);
          const milisegundos: number = Number(this.datoActualIntradia[0]);
          this.fechaIntradiaSlide = util.formatoFecha(milisegundos, 'Diario');
          var ds: any = {
            name: '',
            data: this.listaIntradia,
            color: 'rgba(0,62,108,0.5)', // Color del área
          };
          this.chartOptionsIntradia = {
            series: ds,
          }
        } else {
          this.finalizarIntervalIntradia();
        }
      }, 600);
    }
  }

  private updateChartData(): Array<SeriesOptionsType> {
    var fecha = this.listaFechas[this.indiceActual];
    this.datoActual = fecha;
    var util: UtilidadDashboard = new UtilidadDashboard();
    this.fechaSlide = util.formatoFecha(this.datoActual, 'Mensual');
    var listaSeries: Array<SeriesOptionsType> = new Array();
    this.chartOptionsPI.series?.forEach(serie => {
      var dataSerie = util.getData(fecha, this.mapaDataSet);
      console.log('updateChartData:dataSerie', dataSerie);
      let serieChart: any = {
        name: this.fechaSlide,
        data: dataSerie,
        type: serie.type
      };
      listaSeries.push(serieChart);
    });
    return listaSeries;
  }

  public actualizarFechaRango(event: any) {
    var util: UtilidadDashboard = new UtilidadDashboard();
    this.indiceActual = event.target.value;
    var series = this.updateChartData();
    this.chartOptionsPI = {
      subtitle: {
        text: util.formatoFecha(this.datoActual, 'Mensual') + ' <br> <p style="font-size: medium;">' + this.unidad + '</p>',
      },
      series: series,
    }
  }

  public actualizarFecha(event: any) {
    const valor = event.target.value;
    var fecha = this.listaFechas[valor];
    var util: UtilidadDashboard = new UtilidadDashboard();
    this.fechaSlide = util.formatoFecha(fecha, 'Mensual');
  }

  public actualizarFechaRangoIntradia(event: any) {
    var util: UtilidadDashboard = new UtilidadDashboard();
    this.indiceActualIntradia = event.target.value;
    this.datoActualIntradia = this.listaCompletaIntradia[this.indiceActualIntradia];
    this.listaIntradia.push(this.listaCompletaIntradia[this.indiceActualIntradia]);
    var listaData: Array<any[]> = new Array();
    var fechaSiguiente: Date = new Date(this.listaIntradia[0][0]);
    listaData.push([fechaSiguiente, this.listaIntradia[0][1]]);
    var ds: any = {
      name: '',
      data: listaData,
      color: 'rgba(255,0,0,0.5)', // Color del área
    };
    this.chartOptionsIntradia = {
      series: ds,
    }
  }

  public actualizarFechaIntradia(event: any) {
    const valor = event.target.value;
    var fecha = this.listaCompletaIntradia[valor];
    var util: UtilidadDashboard = new UtilidadDashboard();
    this.fechaIntradiaSlide = util.formatoFecha(fecha, 'Diario');
  }

  private finalizarIntervalIPC() {
    clearInterval(this.barRaceInterval);
    this.accionBotonBarRace = 'play';
  }

  private finalizarIntervalIntradia() {
    clearInterval(this.barRaceIntervalIntradia);
    this.accionBotonIntradiaBarRace = 'play';
  }

}
